const caseStudies = [
  {
    value: '28%',
    label: 'Stockout Reduction',
    description: 'Retail demand forecasting improved regional inventory alignment'
  },
  {
    value: '40%',
    label: 'Faster Review Time',
    description: 'Fraud & anomaly detection increased accuracy across datasets'
  },
  {
    value: '60hrs',
    label: 'Monthly Savings',
    description: 'Operations automation framework for global clients'
  },
  {
    value: '100%',
    label: 'Production Ready',
    description: 'Integrated seamlessly into client operations'
  }
];

const CaseStudies = () => {
  return (
    <section data-testid="case-studies-section" className="py-24 px-6 bg-[#1A1A1A]">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 uppercase tracking-wide">
            Proven <span className="text-[#00E600]">Results</span>
          </h2>
          <p className="text-[#B3B3B3] text-lg max-w-2xl mx-auto">
            Real impact delivered to enterprise clients worldwide
          </p>
        </div>

        {/* Case Studies Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 mb-16">
          {caseStudies.map((study, index) => (
            <div
              key={index}
              data-testid={`case-study-card-${index}`}
              className="bg-[#0D0D0D] border border-[#2F2F2F] rounded-lg p-6 md:p-8 text-center hover:border-[#00E600] transition-all duration-300 group hover:shadow-[0_0_30px_rgba(0,230,0,0.2)]"
            >
              <div className="text-3xl md:text-5xl font-bold text-[#00E600] mb-2 group-hover:scale-110 transition-transform duration-300">
                {study.value}
              </div>
              <div className="text-lg md:text-xl font-semibold text-white mb-2 uppercase tracking-wide">
                {study.label}
              </div>
              <div className="text-[#B3B3B3] text-sm">
                {study.description}
              </div>
            </div>
          ))}
        </div>

        {/* Image */}
        <div className="relative rounded-lg overflow-hidden shadow-2xl" data-testid="case-study-image">
          <img 
            src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGFuYWx5dGljc3xlbnwwfHx8fDE3NjEwNDY3NjR8MA&ixlib=rb-4.1.0&q=85"
            alt="Analytics Dashboard"
            className="w-full h-auto"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] to-transparent opacity-60"></div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;